// // src/services/api/axiosSetup.js

// import AppSecureStorage from "../storage/secureStorage";
// import { setLoggedInUser } from "../../features/Auth/authSlice";
// import { setAllSubscription, setLatestSubscriptions } from "../../features/UserInfo/UserSlice";
// import { setAllSubscriptionorg, setLatestSubscriptionsorg } from "../../features/Organization/OrganizationInfo/OrganizationSlice";

// const setupInterceptors = (axiosInstance, store) => {
//     axiosInstance.interceptors.response.use(
//         (response) => response,
//         (error) => {
//             const status = error?.response?.status;
//             if (status === 401) {
//                 const storage = new AppSecureStorage();
//                 storage.clearStorage();
//                 store.dispatch(setLoggedInUser(false));
//                 store.dispatch(setLoggedInUser(null))
//                 store.dispatch(setAllSubscription([]))
//                 store.dispatch(setLatestSubscriptions([]))
//                 store.dispatch(setAllSubscriptionorg([]))
//                 store.dispatch(setLatestSubscriptionsorg([]))
//                 store.setTimeout(() => {
//                     window.location.href = "/";
//                 }, 200);
//             }
//             return Promise.reject(error);
//         }
//     );
// };

// export default setupInterceptors;


// src/services/api/axiosSetup.js

import AppSecureStorage from "../storage/secureStorage";
import { setLoggedInUser } from "../../features/Auth/authSlice";
import { setAllSubscription, setLatestSubscriptions } from "../../features/UserInfo/UserSlice";
import { setAllSubscriptionorg, setLatestSubscriptionsorg } from "../../features/Organization/OrganizationInfo/OrganizationSlice";

const setupInterceptors = (axiosInstance, store) => {
    axiosInstance.interceptors.response.use(
        (response) => response,
        (error) => {
            const status = error?.response?.status;

            if ([401, 
                // 403,
                 419, 440
            ].includes(status)) {
                const storage = new AppSecureStorage();
                storage.clearStorage();

                store.dispatch(setLoggedInUser(false));
                store.dispatch(setLoggedInUser(null));
                store.dispatch(setAllSubscription([]));
                store.dispatch(setLatestSubscriptions([]));
                store.dispatch(setAllSubscriptionorg([]));
                store.dispatch(setLatestSubscriptionsorg([]));

                setTimeout(() => {
                    window.location.href = "/";
                }, 200);
            }

            return Promise.reject(error);
        }
    );
};

export default setupInterceptors;
